import { styled } from "@mui/system";
import { Link as RouterLink } from "react-router-dom";
import RightArrowIcon from "src/icons/portfolio/RightArrowIcon";
import { IRecentTransactionData } from "../defaults";
import { trackEvent } from "src/Amplitude";

export const TXHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  justifyContent: "space-between",
  gap: "4px",
}));

export const TXSubHeader = styled(RouterLink)({
  fontSize: "14px",
  cursor: "pointer",
  textDecoration: "none",
  color: "inherit",
  "&:hover": {
    opacity: 0.7,
  },
});

export const TXHeaderIcon = styled(RouterLink)({
  cursor: "pointer",
  textDecoration: "none",
  color: "inherit",
});

export const TXContentWrapper = styled("ul")(({ theme }) => ({
  all: "unset",
  display: "flex",
  height: "226px",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "12px",
  alignSelf: "stretch",

  [theme.breakpoints.down(1440)]: {
    height: "auto",
    justifyContent: "center",
  },
}));

export const TXContent = styled("li")({
  all: "unset",
  display: "flex",
  alignItems: "center",
  gap: "40px",
  alignSelf: "stretch",
});

export const TXCT = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "2px",
  flex: "1 0 0",
});

export const TXCTHeader = styled("div")(({ theme }) => ({
  display: "flex",
  width: "178px",
  justifyContent: "space-between",
  alignItems: "center",
  fontSize: "14px",
  fontWeight: 600,

  [theme.breakpoints.down(1440)]: {
    width: "auto",
    alignSelf: "stretch",
  },
}));

export const TXCTSubHeader = styled("div")(({ theme }) => ({
  display: "flex",
  width: "178px",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "8px",
  fontSize: "14px",

  [theme.breakpoints.down(1440)]: {
    width: "auto",
    alignSelf: "stretch",
  },
}));

export const TXViewButton = styled(RouterLink)(({ theme }) => ({
  display: "flex",
  padding: "6px 18px",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  borderRadius: "16px",
  border: `1px solid ${theme.palette.primary.main}`,
  background: theme.palette.background.paper,
  fontSize: "14px",
  cursor: "pointer",
  textDecoration: "none",
  color: theme.palette.text.primary,

  "&:hover": {
    background: theme.palette.primary.contrastText,
  },

  "&:focus": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light,
  },
}));

interface DesktopRecentTransactionsProps {
  data: IRecentTransactionData[];
}

const PortfolioTransactions = (props: DesktopRecentTransactionsProps) => {
  const { data } = props;

  const handleAmplitudeTracking = (action: string) => {
    trackEvent(action, undefined, "PortfolioTransactions");
  };

  return (
    <>
      {/* HEADER */}
      <TXHeader>
        <TXSubHeader
          to="/transactions/overview"
          onClick={() => handleAmplitudeTracking(`Clicked 'Your recent transactions' Button`)}>
          Your recent transactions
        </TXSubHeader>
        <TXHeaderIcon to="/transactions/overview">
          <RightArrowIcon />
        </TXHeaderIcon>
      </TXHeader>

      {/* CONTENT */}
      <TXContentWrapper id="recent-transactions-list">
        {data.map((tx) => (
          <TXContent key={tx.ctid}>
            {/* CT */}
            <TXCT>
              <TXCTHeader>
                <div>{tx.type}</div>
                <div>CT{tx.ctid}</div>
              </TXCTHeader>
              <TXCTSubHeader>
                <div translate="no">{tx.value}</div>
                <div>{tx.date}</div>
              </TXCTSubHeader>
            </TXCT>
            {/* BUTTON */}
            <TXViewButton
              data-testid="#recentTransactions-view-button"
              to={`/transactions/overview?ct=${tx.ctid}`}
              onClick={() => handleAmplitudeTracking("View Button")}>
              View
            </TXViewButton>
          </TXContent>
        ))}
      </TXContentWrapper>
    </>
  );
};

export default PortfolioTransactions;
